import { useEffect, useState } from "react";
import { Button, Table, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { getConsentTemplates } from "../../apis/consent";
import { ConsentTemplate } from "../../interfaces/Consent";
import { useNotification } from "../../NotificationContext";

const ConsentTemplateList = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [templates, setTemplates] = useState<ConsentTemplate[]>([]);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    getConsentTemplates()
      .then((res: any) => setTemplates(res.data ?? res))
      .catch(() => showNotification("error", "Failed to load templates", "", "topRight"))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const columns = [
    {
      title: "Key",
      dataIndex: "key",
      key: "key",
      render: (k: string) => <span className="font-mono text-xs text-indigo-600">{k}</span>,
    },
    { title: "Name", dataIndex: "name", key: "name" },
    {
      title: "Pattern",
      dataIndex: "pattern",
      key: "pattern",
      render: (p: string) => <Tag>{p}</Tag>,
    },
    {
      title: "Fields",
      key: "fields",
      render: (_: any, tpl: ConsentTemplate) => (
        <Tag>{tpl.fields?.length ?? 0} fields</Tag>
      ),
    },
    {
      title: "Pages",
      dataIndex: "pageCount",
      key: "pageCount",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, tpl: ConsentTemplate) => (
        <Button size="small" onClick={() => navigate(`/consent-templates/${tpl.id}`)}>
          View
        </Button>
      ),
    },
  ];

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-semibold">Consent Templates</h1>
      </div>

      <Table
        dataSource={templates}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{ pageSize: 20 }}
      />
    </div>
  );
};

export default ConsentTemplateList;
